import { Injectable } from '@angular/core';
import { JobStatus } from '../models/generated/ziroModels';
import { PollingAbstractService } from '../services/abstract/polling.abstract.service';

@Injectable()
export class GlobalDirectoryPollingService extends PollingAbstractService<JobStatus> {
  baseUrl = '/services/cisco/reporting/global-directories/status';
}
